import { createContext } from "react";
const CareerContext = createContext({});
export default CareerContext;
